import Cookies from "js-cookie";

import { ACCESS_TOKEN_KEY, COOKIES_COMPANY_ID } from "../utils/constants";
import { fakeAPIRequest, unmarshallDynamoDB } from "../utils/helper";
import { setAuthHeader, apiService } from "./api";
import { dummyDrivers } from "../tests/data";
import { Driver } from "../models";

export async function fetchEquipment() {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(
    `/company/${companyId}/equipments?type=availability`
  );

  return response.data;
}

export async function fetchDrivers() {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(
    `company?type=getAvailableDrivers&companyId=${companyId}`
  );

  const data = response.data?.drivers as any[];

  const drivers = data.map<Driver>((item) => ({
    id: item.userID,
    email: item.email,
    name: item.name,
    verified: item.verificationStatus === 'verified',
    profileImage: item.profileImage,
    phoneNumber: item.phoneNumber ?? "--",
    availability: [],
  }));

  return {
    data: drivers,
  };
}

export async function updateDriver({
  driverID,
  equipmentID,
  type,
}: {
  driverID: string;
  equipmentID: string;
  type: "assign" | "unassign";
}) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);
  const action =
    type === "assign"
      ? "assignDriverToEquipment"
      : "unassignDriverFromEquipment";

  setAuthHeader(`${token}`);

  const response = await apiService.post(
    `company?type=${action}&companyId=${companyId}`,
    {
      driverID,
      equipmentID,
    }
  );

  console.log("assign result", response.data);
}

export async function fetchDriverDetails(driverID: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  await fakeAPIRequest(companyId!);

  const driver = dummyDrivers.find((driver) => driver.id === driverID);

  // const response = await apiService.post(
  //   `/company/${companyId}/custody/${bidID}/accept`
  // );

  // return response.data;

  return { data: driver };
}

export async function fetchEquipmentDetails(equipmentID: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(
    `/company/${companyId}/equipments/${equipmentID}?type=getEquipmentDetails`
  );

  const { equipment } = response.data;

  if (equipment) {
    const data = unmarshallDynamoDB(equipment);
    console.log("unmarshal", data);
    return data;
  } else {
    return undefined;
  }
}

export async function updateEquipmentAvailabilityAPI(
  equipmentID: string,
  available: boolean
) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.post(
    `/company/${companyId}/equipments/${equipmentID}/availability`,
    { available }
  );

  return response;
}

export async function overrideEquipmentAPI({
  shipperID,
  equipmentID,
  loadID,
  oldEquipmentLP,
}: {
  equipmentID: string;
  oldEquipmentLP: string;
  shipperID: string;
  loadID: string;
}) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.post(
    `/company/${companyId}/equipments/${equipmentID}/override-assignment`,
    { shipperID, loadID, oldEquipmentLP }
  );

  return response;
}

// withLocations=true makes the backend attach each equipment's latest live
// location (`location: { lat, lon, heading?, lastUpdatedEpoch? } | null`), so
// the dashboard can refresh every marker with a single request.
export async function fetchEquipmentWithLoads(
  data: any[],
  { withLocations = false }: { withLocations?: boolean } = {}
) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const encodedlps = encodeURIComponent(JSON.stringify(data));

  const response = await apiService.get(
    `/company/${companyId}/equipments?type=loadAssigned&lps=${encodedlps}${
      withLocations ? "&withLocations=true" : ""
    }`
  );

  return response.data;
}

export async function fetchCompatibleEquipment(
  loadCategory: string,
  carrierSecurity: string[]
) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.get(
    `/company/${companyId}/equipments?type=loadCompatible&loadCategory=${loadCategory}&loadCarrierSecurity=${JSON.stringify(
      carrierSecurity
    )}`
  );

  return response.data;
}
